export const POSITIONS = [
    'Directeur(trice)',
    'Assistant(e) de direction',
    'Chef de projet',
    'Chef d\'équipe',
    'Responsable commercial(e)',
    'Conducteur(trice) de travaux',
    'Responsable technique',
    'Architecte paysagiste senior',
    'Autre'
  ] as const;
  
  export type Position = typeof POSITIONS[number];